import React, { Fragment, useState } from 'react';
import { useSelector } from 'react-redux';
import { Redirect } from 'react-router-dom';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { Header, Dropdown, Icon } from 'semantic-ui-react';
import i18next from 'i18next';
import BranchMenuItems from './nav-menu/BranchMenuItems';
import ChainMenuItems from './nav-menu/ChainMenuItems';
import AppContainer from '../app-container/AppContainer';
import SubContainer from '../app-container/SubContainer';
import { hasBusinessPermission } from '../../helpers/permissions';
import { getBusinessesForPicker } from '../../selectors';

const BusinessContainer = ({ children, ...props }) => {
    const businesses = useSelector(state => getBusinessesForPicker(state));
    const [pickerValue, setPickerValue] = useState('');

    const { restId: branchId, chainId } = props.match.params;
    const currentType = chainId ? 'chain' : 'branch';
    const currentBusiness = businesses.filter(b => b.type === currentType).find(o => o.id === (chainId || branchId));

    function renderPicker(customTrigger) {
        const options = businesses.map(b => ({
            key: `${b.type[0]}${b.id}`,
            value: `${b.type[0]}${b.id}`,
            text: `${i18next.t(b.type === 'chain' ? 'chain.name' : 'branch')} - ${b.name}`,
            as: Link,
            to: b.type === 'chain' ? `/chain/${b.id}` : `/restaurant/${b.id}`,
            label: { color: b.type === 'chain' ? 'blue' : undefined, empty: true, circular: true }
        }));
        const value = chainId ? `c${chainId}` : `b${branchId}`;

        function renderCustomTrigger() {
            if (customTrigger) {
                return (
                    <Fragment>
                        <div style={{ display: pickerValue ? 'none' : 'flex', color: '#a7a7a7', marginBottom: -15 }}>
                            <Icon name='search' style={{ fontSize: 14 }} /> {i18next.t('switchBranchChain')}
                        </div>
                        <Header size='large'>
                            <Header.Content>
                                {currentBusiness.name}
                                <Header.Subheader>{i18next.t(currentBusiness.type === 'chain' ? 'chain.name' : 'branch')}</Header.Subheader>
                            </Header.Content>
                        </Header>
                    </Fragment>
                );
            }
        }

        return (
            <Dropdown
                trigger={renderCustomTrigger()}
                options={options}
                value={value}
                fluid
                item
                search
                placeholder="search"
                icon={null}
                onSearchChange={(e, { searchQuery }) => setPickerValue(searchQuery)}
                onClose={e => {
                    setPickerValue('');
                }}
            />
        );
    }

    function renderMenuItems(iconOnly) {
        return (
            <Fragment>
                {chainId ? <ChainMenuItems iconOnly={iconOnly} chainId={chainId} {...props} /> : null}
                {branchId ? <BranchMenuItems iconOnly={iconOnly} branchId={branchId} {...props} /> : null}
            </Fragment>
        );
    }

    if (!hasBusinessPermission()) {
        return <Redirect to={{ pathname: '/' }} />;
    }

    if (!currentBusiness) return <AppContainer {...props}>{children}</AppContainer>;

    return (
        <SubContainer
            renderPicker={renderPicker}
            renderMenuItems={renderMenuItems}
            menuItemsCount={chainId ? 5 : 9}
            {...props}
        >
            {children}
        </SubContainer>
    );
};

BusinessContainer.propTypes = {
    children: PropTypes.any,
    
    match: PropTypes.object
};

export default BusinessContainer;
